import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import PageHeader from '@/components/PageHeader';
import PurchaseList from './purchase-list';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Purchases">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item active>Purchases</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <PurchaseList />
    </Panel>
  );
};

export default Page;
